import { computed, Injectable, signal } from '@angular/core';
import { ModalType } from 'src/ui/components/modal/modal.component';

export interface ModalConfig {
  title: string;
  message?: string;
  type?: ModalType;
  confirmText?: string;
  cancelText?: string;
  showCancel?: boolean;
  showCloseIcon?: boolean;
  closeOnBackdrop?: boolean;
  confirmDisabled?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
}

@Injectable({ providedIn: 'root' })
export class ModalService {
  private readonly configSignal = signal<ModalConfig | null>(null);

  readonly config = this.configSignal.asReadonly();
  readonly visible = computed(() => this.configSignal() !== null);

  show(config: ModalConfig): void {
    this.configSignal.set(config);
  }

  confirm(): void {
    const current = this.configSignal();
    this.configSignal.set(null);
    current?.onConfirm?.();
  }

  cancel(): void {
    const current = this.configSignal();
    this.configSignal.set(null);
    current?.onCancel?.();
  }

  close(): void {
    this.configSignal.set(null);
  }
}
